import mouvementApi from '@/api/mouvement.api'

const getDefaultState = () => {
  return {
    detailMouvement: {}
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),

  getters: {
    detailMouvement (state) {
      return state.detailMouvement
    }
  },
  mutations: {
    SET_DETAIL_MOUVEMENT (state, detailMouvement) {
      state.detailMouvement = detailMouvement
    }
  },
  actions: {
    getDetailMouvement ({ commit, rootGetters }, params) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return mouvementApi.getDetailMouvement(username, params.numeroBon, params.numeroContrat)
        .then(result => {
          return commit('SET_DETAIL_MOUVEMENT', result)
        })
    }
  }
}

export default module
